import { useEffect, useState } from "react";
import { Model } from "../interfaces";
import { removeFromFilesArray } from "../utils/others";

const useLoader = (model: Model | null, refresh: boolean) => {
  const [filesOnInput, setFilesOnInput] = useState<any[]>([]);
  const [filesBase64, setFilesBase64] = useState<any[]>([]);
  const [filesPreviewSrc, setFilesPreviewSrc] = useState<any[]>([]);
  const [fileType, setFileType] = useState("");

  const getBase64 = async (file: File) => {
    let b64 = "";
    if (file) {
      await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
      }).then((data) => {
        const s: any = data;
        b64 = s; /* .replace("data:", "").replace(/^.+,/, ""); */
      });
    }
    return b64;
  };

  const getPreviewSrc = (file: File) => {
    let src = "";
    if (file) {
      src = URL.createObjectURL(file);
    }
    return src;
  };

  const getFiles = (e: any) => {
    const files: File[] = [];
    for (let i = 0; i < e.target.files.length; i++) {
      files.push(e.target.files[i]);
    }
    return filesOnInput.concat(files);
  };

  const process = (e: any, fileType?: string) => {
    if (fileType) setFileType(fileType);
    let files = [];
    if (fileType && fileType === "profileImage") {
      files = e.target.files;
    } else files = getFiles(e);
    setFilesOnInput(files);
  };
  const remove = (index: number, file: any) => {
    const final = removeFromFilesArray(index, file, filesOnInput);
    setFilesOnInput(final);
  };

  useEffect(() => {
    const base64Array: any[] = [];
    if (fileType && fileType === "profileImage") {
      let b64 = getBase64(filesOnInput[0]);
      b64.then((data) => {
        return base64Array.push({ [fileType]: data });
      });
    } else {
      // Per inserire indice per Gianlu, probabile soluzione
      for (let i = 0; i < filesOnInput.length; i++) {
        const file = filesOnInput[i];
        let b64 = getBase64(file);
        b64.then((data) => {
          if (fileType === "document") {
            return base64Array.push({
              [fileType]: data,
              name: file.name,
              index: i,
            });
          } else {
            return base64Array.push({ [fileType]: data, index: i });
          }
        });
      }

      /* filesOnInput.forEach((file) => {
        let b64 = getBase64(file);
        b64.then((data) => {
          if (fileType === "document") {
            return base64Array.push({
              [fileType]: data,
              name: file.name,
            });
          } else {
            return base64Array.push({ [fileType]: data });
          }
        });
      }); */
    }
    setFilesBase64(base64Array);
  }, [filesOnInput]);

  useEffect(() => {
    const previewSrcArray: string[] = [];
    if (fileType && fileType === "profileImage") {
      previewSrcArray.push(getPreviewSrc(filesOnInput[0]));
    } else {
      filesOnInput.forEach((file) => {
        previewSrcArray.push(getPreviewSrc(file));
      });
    }
    setFilesPreviewSrc(previewSrcArray);
  }, [filesOnInput]);

  useEffect(() => {
    setFilesBase64([]);
    setFilesPreviewSrc([]);
  }, [refresh]);

  /*  console.log(filesOnInput); */

  return { filesOnInput, filesBase64, filesPreviewSrc, process, remove };
};
export default useLoader;

/* URL.revokeObjectURL(objFile) */
